import { UserSelectAllOutputDataVehicleList } from './user-select-all-output-data-vehicle-list.model';


export class UserSelectAllOutputData implements IUserSelectAllOutputData {
    /** The auto-generated id of the user master */
    user_id!: number;
    /** The company name */
    company_name!: string;
    /** The branch name */
    branch_name!: string;
    allocated_vehicles!: UserSelectAllOutputDataVehicleList[];
    /** The user type name with 255 character limit */
    user_name!: string;
    /** The user mobile number with 13 character limit */
    mobile_no!: string;
    /** The user email address with 320 character limit */
    email_address!: string;
    /** The application module name */
    application_module!: string;
    /** The user group name */
    user_group!: string;
    /** The auto-generated creating time of tbl_user_detail item add */
    creating_date!: any;
    /** The auto-generated creating or updating time of tbl_user_detail item add or update */
    updating_date!: any;
    /** The last access time */
    last_access_time!: any;
    status!: number;

    constructor(data?: IUserSelectAllOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_id = _data["user_id"];
            this.company_name = _data["company_name"];
            this.branch_name = _data["branch_name"];
            if (Array.isArray(_data["allocated_vehicles"])) {
                this.allocated_vehicles = [] as any;
                for (let item of _data["allocated_vehicles"])
                    this.allocated_vehicles!.push(UserSelectAllOutputDataVehicleList.fromJS(item));
            }
            this.user_name = _data["user_name"];
            this.mobile_no = _data["mobile_no"];
            this.email_address = _data["email_address"];
            this.application_module = _data["application_module"];
            this.user_group = _data["user_group"];
            this.creating_date = _data["creating_date"];
            this.updating_date = _data["updating_date"];
            this.last_access_time = _data["last_access_time"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserSelectAllOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new UserSelectAllOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_id"] = this.user_id;
        data["company_name"] = this.company_name;
        data["branch_name"] = this.branch_name;
        if (Array.isArray(this.allocated_vehicles)) {
            data["allocated_vehicles"] = [];
            for (let item of this.allocated_vehicles)
                data["allocated_vehicles"].push(item.toJSON());
        }
        data["user_name"] = this.user_name;
        data["mobile_no"] = this.mobile_no;
        data["email_address"] = this.email_address;
        data["application_module"] = this.application_module;
        data["user_group"] = this.user_group;
        data["creating_date"] = this.creating_date;
        data["updating_date"] = this.updating_date;
        data["last_access_time"] = this.last_access_time;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserSelectAllOutputData {
    /** The auto-generated id of the user master */
    user_id: number;
    /** The company name */
    company_name: string;
    /** The branch name */
    branch_name: string;
    allocated_vehicles: UserSelectAllOutputDataVehicleList[];
    /** The user type name with 255 character limit */
    user_name: string;
    /** The user mobile number with 13 character limit */
    mobile_no: string;
    /** The user email address with 320 character limit */
    email_address: string;
    /** The application module name */
    application_module: string;
    /** The user group name */
    user_group: string;
    /** The auto-generated creating time of tbl_user_detail item add */
    creating_date: any;
    /** The auto-generated creating or updating time of tbl_user_detail item add or update */
    updating_date: any;
    /** The last access time */
    last_access_time: any;
    status: number;
}

